import loadingIndicatorIconComponent from './loadingIcon.component';

const loadingIndicatorIconModule = angular.module('app.common.loadingIndicatorIcon', [])
	.component('loadingIcon', loadingIndicatorIconComponent)
	.name;

export default loadingIndicatorIconModule;
